import { ResourceStore } from './resource.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";

@Injectable({ providedIn: 'root' })
export class ResourceQuery extends BaseQuery {

    constructor(store: ResourceStore) {
        super(store);
    }
}
